import { observer } from "mobx-react-lite"
import { Form, Table } from "antd"
import { useForm } from "antd/es/form/Form"

import { TokenType } from "@src/pages/settingsApiKeys/classes/TokensCollection"
import ScopesSelect from "@src/pages/settingsApiKeys/ui/ScopesSelect"

type Props = {
  groups: Record<string, string[]>
  record: TokenType
}
export const TokensTableExpand = observer(({ groups, record }: Props) => {
  const [form] = useForm()

  return (
    <Form form={form}>
      <ScopesSelect isReadonly scopesGroups={groups} selected={record.scopes} />
    </Form>
  )
})
